export enum CourseAssignmentStatus {
  OPEN_TO_SUBMIT,
  CLOSE_TO_SUBMIT,
}
